import React, {useEffect, useState} from "react";
import {apiGetDashboardInfo} from "./Actions";
import {DefaultLoader} from "../../../components/DefaultLoader";
import {useSelector} from "react-redux";
import Toast from "cogo-toast";
import Widget from "../../../components/widget";
import UserArealSelect from "../Turnstiles/UserArealSelect";

const SystemInfo = () => {

    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);
    let user = useSelector((state) => state.user);

    useEffect(() => {
        user.activeAreal && getData();
    }, [user.activeAreal]);

    const getData = () => {
        setLoading(true);
        apiGetDashboardInfo(user.activeAreal.id, (response) => {
            setData(response);
            setLoading(false);
        }, (error) => {
            Toast.error("Při načítání informací nastala chyba.");
            setData(null);
            setLoading(false);
        });
    }

    const _renderBody = () => {
        if (loading) return <DefaultLoader text={"Načítám informace..."}/>;
        if (!data) return <div>Žádná data</div>;

        return (
            <div className={"grid grid-cols-2 gap-4 p-4"}>
                <InfoRow label={"Databáze"} value={data.dbState}/>
                <InfoRow label={"TCP"} value={data.tcpState}/>
                <InfoRow label={"UDP"} value={data.udpState}/>
                <InfoRow label={"Uptime"} value={data.uptime}/>
                <InfoRow label={"Paměť použitá"} value={data.memoryUsed + " MB"}/>
                <InfoRow label={"Paměť celkem"} value={data.memoryTotal + " MB"}/>
                <InfoRow label={"Disk použitý"} value={data.usedDiskSpace ? data.usedDiskSpace.toFixed(1) + " GB" : "-"}/>
                <InfoRow label={"Disk celkem"} value={data.totalDiskSpace ? data.totalDiskSpace.toFixed(1) + " GB" : "-"}/>
                <InfoRow label={"Verze aplikace"} value={data.appVersion}/>
                <InfoRow label={"Build"} value={data.appBuildTime}/>
                <InfoRow label={"Server"} value={data.serverName}/>
                <InfoRow label={"OS"} value={data.osName}/>
                <InfoRow label={"Java"} value={data.javaVersion}/>
                <InfoRow label={"Vstupy dnes"} value={data.uniqueEntranceToday}/>
                <InfoRow label={"Obrázků"} value={data.imagesCount}/>
                <InfoRow label={"Velikost obrázků"} value={data.imagesSizeAll}/>
            </div>
        );
    }

    return (
        <>
            <UserArealSelect/>
            <Widget title={"Informace o systému"}>
                {user.activeAreal ? _renderBody() : null}
            </Widget>
        </>
    );
}

const InfoRow = ({label, value}) => (
    <div className={"flex flex-col"}>
        <span className={"text-xs text-gray-500"}>{label}</span>
        <span className={"font-medium"}>{value ?? "-"}</span>
    </div>
);

export default SystemInfo;
